(() => {
  const initialize = () => {
  const dialog = document.getElementById('CsCurrencyDialog');
  const form = document.getElementById('localization_form');
  const input = document.getElementById('CurrencySelector');
  if (!dialog || !form || !input || typeof dialog.showModal !== 'function') return;
  const status = dialog.querySelector('.cs-cur-status');
  const options = [...dialog.querySelectorAll('[data-cs-currency-code]')];
  const triggers = [...document.querySelectorAll('[data-cs-currency-open]')];
  let opener;
  let busy = false;
  const reset = () => {
    busy = false;
    options.forEach(button => { button.disabled = false; });
    dialog.removeAttribute('aria-busy');
    status.textContent = '';
  };
  triggers.forEach(button => button.addEventListener('click', () => {
    opener = button;
    document.getElementById('settingsBox')?.classList.remove('active');
    if (!dialog.open) {
      reset();
      dialog.showModal();
      (dialog.querySelector('[aria-current="true"]') || options[0])?.focus({ preventScroll: true });
    }
  }));
  dialog.querySelector('[data-cs-currency-close]').addEventListener('click', () => { if (!busy) dialog.close(); });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (!busy && event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  dialog.addEventListener('close', () => { opener?.focus({ preventScroll: true }); });
  options.forEach(button => button.addEventListener('click', () => {
    if (busy) return;
    const code = button.dataset.csCurrencyCode;
    if (code === dialog.dataset.currentCode) { dialog.close(); return; }
    input.value = code;
    busy = true;
    options.forEach(option => { option.disabled = true; });
    dialog.setAttribute('aria-busy', 'true');
    status.textContent = dialog.dataset.updating;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(form);
    } catch {
      reset();
      status.textContent = dialog.dataset.error;
    }
  }));
  window.addEventListener('pageshow', reset);
  dialog.setAttribute('data-cs-currency-ready', 'true');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
